/* import __COLOCATED_TEMPLATE__ from './manual-intermediate-time-entry-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ManualStartTimeComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked intermediateTime = "";
	@tracked timingPoint = null;
	
	@action
	async enterIntermediateTime(browserEvent)
	{
		browserEvent.preventDefault();

		var time = new Date(this.intermediateTime);

		if(isNaN(time.getTime()))
		{
			alert('Invalid time format. Please enter a valid date/time.');
			return;
		}

		const impulse = this.store.createRecord('TimingImpulse',
		{
			time: time,
		});
		impulse.EventId = this.args.event;
		await impulse.save();

		var iTR = this.store.createRecord('IntermediateTimingRecord',
		{
			isPosted: false,
			participatesInAutoAssociation: false
		});
		iTR.impulseId = impulse;
		iTR.EventId = this.args.event;
		iTR.IntermediateTimingPointId = this.timingPoint;

		await iTR.save();
	}
	
	@action
	async timingPointSelectionChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.timingPoint = null;
		}
		else
		{
			const tp = await this.store.findRecord('IntermediateTimingPoint',browserEvent.target.value);
			this.timingPoint = tp;
		}
	}
}
